import { Trans } from '@lingui/react/macro';

import { Button } from '@/shared/ui/button';

export function AppCrash() {
  return (
    <main className="grid min-h-dvh place-items-center bg-background p-6 text-center">
      <div className="flex max-w-sm flex-col items-center gap-3">
        <h1 className="text-xl font-semibold">
          <Trans>Algo deu errado nesta tela</Trans>
        </h1>
        <p className="text-sm text-muted-foreground">
          <Trans>O erro foi registrado. Recarregue a página; se continuar, fale com o suporte.</Trans>
        </p>
        <Button onClick={() => window.location.reload()}>
          <Trans>Recarregar</Trans>
        </Button>
      </div>
    </main>
  );
}
